import { useState } from "react";

import { useUser } from "@components/user-context";
import {
  type Annotation,
  type NewAnnotation,
} from "@features/custom-annotations";

export const useAnnotationForm = (isMmm: boolean) => {
  const { user } = useUser();
  const [currentAnnotation, setCurrentAnnotation] = useState<
    Annotation | NewAnnotation | null
  >(null);

  const buildNewAnnotation = (annotatedDate: string): NewAnnotation => {
    const newAnnotation: NewAnnotation = {
      clientId: user.displayUserId,
      userId: user.authedUserId,
      description: "",
      annotatedDate: annotatedDate,
    };
    if (isMmm) {
      newAnnotation.campaignType = "";
      newAnnotation.endDate = "";
    }
    return newAnnotation;
  };

  const newAnnotation = (annotatedDate = "") =>
    setCurrentAnnotation(buildNewAnnotation(annotatedDate));
  const editAnnotation = (annotation: Annotation) =>
    setCurrentAnnotation(annotation);

  return {
    currentAnnotation,
    newAnnotation,
    editAnnotation,
    clearCurrentAnnotation: () => setCurrentAnnotation(null),
  };
};
